export default class goToCheckoutButton {
    constructor (element) {
        this.element = element
        this.element.addEventListener('keydown', this.handleKeyDown.bind(this))
    }

    handleKeyDown (e) {
        if (e.key && e.key !== 'Enter') {
            return
        }
        e.preventDefault()
        this.element.setAttribute('checked', 'checked')
        this.triggerChangeEvent(this.element)
    }

    triggerChangeEvent (item) {
        const event = new Event('change')
        item.dispatchEvent(event)
    }
}
